export default "4b0c570182767076.svg"